import React, { useMemo } from 'react';
import { FixedSizeList } from 'react-window';
const VirtualizedMenuList = ({ options, children, getValue, virtualizationConfig, }) => {
    const { maxHeight, width, itemSize } = virtualizationConfig;
    const [value] = getValue();
    const initialOffset = useMemo(() => options.findIndex((option) => option.value === (value === null || value === void 0 ? void 0 : value.value)) * itemSize, [options, value]);
    return (
    // @ts-ignore Until material ui and react-transition-group update their react deps
    React.createElement(FixedSizeList, { width: width, height: maxHeight, itemCount: options.length, itemSize: itemSize, initialScrollOffset: initialOffset }, ({ index, style }) => (React.createElement("div", { style: Object.assign(Object.assign({}, style), { width: '98%' }) }, children && children[index]))));
};
export default VirtualizedMenuList;
//# sourceMappingURL=VirtualizedMenuList.js.map